<template>
  <f7-page name="asset-last-alarms">

    <f7-progressbar v-if="isLoading" color="green" infinite class="progressbar-top" key="1"></f7-progressbar>
    <!-- Top Navbar -->
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ f7route.query.name }}</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="getAlarms">
          <i class="icon f7-icons icon-refresh"></i>
        </f7-link>
      </f7-nav-right>
    </f7-navbar>


    <f7-block>
      <p>{{ $t('AlarmsForPastDays', {d: pastDays}) }}</p>
    </f7-block>

    <f7-block v-if="!isLoading && isNoData">
      <p>{{ $t('NoAlertsFound') }}</p>
    </f7-block>

    <f7-list
        ref="vl"
        class="vl vl-last-alarms no-margin-top"
        virtual-list
        media-list
        :virtual-list-params="{ items, renderExternal, height: heightCalc }"
    >
      <ul>
        <f7-list-item
            v-for="(item, index) in vlData.items"
            link="#"
            :key="index"
            :title="item.CustomAlarmName"
            :header="item.CustomAlarmTime"
            :style="`top: ${vlData.topPosition}px`"
            @click="openItem(item, index)"
        >
        </f7-list-item>
      </ul>
    </f7-list>

  </f7-page>
</template>

<script>
import { QTAPI } from "../../services/qt-api";
import { getPositionAlertsTranslations } from "../../js/helpers"
import {mapGetters} from "vuex";
//import {HideKeyboard, SortArrayByObjProps} from "../js/helpers";
import {f7, theme} from "framework7-vue";
import moment from "moment-mini";

export default {
  name: "asset-last-alarms",

  computed: {
    ...mapGetters(['MajorToken'])
  },

  props: {
    f7router: Object,
    f7route: Object,
  },

  data() {
    return {
      isLoading: false,
      isNoData: true,
      pastDays: 7,

      items: [],
      vlData: {
        items: [],
      },
      vl: null,
    }
  },

  mounted() {
    this.vl = f7.virtualList.get('.vl-last-alarms');
    this.getAlarms()

  },

  methods: {
    async getAlarms(){
      this.isLoading = true

      var data = {
        MinorToken: this.MajorToken,
        asId: this.f7route.query.id,
        begin: moment().subtract(this.pastDays, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
      };

      //let result = await QTAPI.GetAssetLastAlarms(data);
      let result = await QTAPI.GetAssetAlarmHistory(data);

      this.isLoading = false

      if(!result){
        return
      }
      this.isNoData = !result.length;
      if(result.length){
        //result = SortArrayByObjProps([...result], [{prop: 'Name', direction: 1}])
        result = this.formatAlertHistory(result)
        this.vl.replaceAllItems(result);
      }else{
        this.vl.deleteAllItems()
      }

    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },
    heightCalc(){
      return theme.ios ? 60 : 66;
    },
    formatAlertHistory(alerts){
      let alertsEnum = getPositionAlertsTranslations()
      for (const alert of alerts) {
        let datetime = moment.utc(alert.AlarmTime, 'YYYY-MM-DD HH:mm:ss').toDate();
        alert.CustomAlarmName = alertsEnum[parseInt(alert.AlarmType)] ? alertsEnum[parseInt(alert.AlarmType)] : alert.AlarmType
        alert.CustomAlarmTime = moment(datetime).format('YYYY-MM-DD HH:mm:ss');
      }
      return alerts
    },
    openItem(item){
      f7.views.main.router.navigate({
        name: 'asset-alarm-position',
        query: {
          name: this.f7route.query.name,
        }
      }, {
        props: {alertData: item}
      })
    }
  }
}
</script>

<style scoped>

</style>